import React, {  useCallback } from "react";
import {  Form, Message } from "semantic-ui-react";
import { AddBtn } from "../AddBtn";
import List from "../List";
import { CustomLoader } from "../formComponents/loader";
import AmendmentReasonForm from "./AmendmentReasonForm";
import { FormTitle } from "../FormTitle";

const Amendment = ({isLoading,AddItem,deleteItem,updateItem,saveItem,dataSource,amendReasonTypeList,formConfig={}}) => {
  
  const isAmendReasonAlreadyExists=useCallback((selectedReason)=>{
    return dataSource.some(c=>c.reason==selectedReason)
  },[dataSource])
  
  const renderItem=useCallback((item)=>{
    return <AmendmentReasonForm
    key={item.id}
    item={item}
    updateData={updateItem}
    deleteData={deleteItem}
    saveData={saveItem}
    amendReasonTypeList={amendReasonTypeList}
    formConfig={formConfig}
    isAmendReasonAlreadyExists={isAmendReasonAlreadyExists}
    />
   },[updateItem, saveItem,deleteItem,amendReasonTypeList,isAmendReasonAlreadyExists,formConfig])

  return (
    <Message>
    <Form.Group className="float-container">
         <FormTitle title="AMENDMENT REASON(S)"></FormTitle>
        <List 
          dataSource={dataSource}
          renderItem={renderItem}
        />
  
      { isLoading && <CustomLoader /> }
      {
        (dataSource?.length!=amendReasonTypeList?.length) && 
        <AddBtn {...formConfig}  id={`amendReasonAdd`} onClick={AddItem}  text='Add' />
      }

     
      </Form.Group>
      </Message>
   
   );
}
export default React.memo(Amendment)
